import { render, staticRenderFns } from "./BoHome.vue?vue&type=template&id=3e940d1e&"
import script from "./BoHome.vue?vue&type=script&lang=js&"
export * from "./BoHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports